import { ReactNode } from "react";

// Dictionary strings mark inline code with backticks: "run `cdd check` first"
export function renderInlineCode(text: string): ReactNode[] {
  return text
    .split("`")
    .map((part, index) => (index % 2 === 1 ? <code key={index}>{part}</code> : part));
}
